import { ChevronDownIcon } from '@twistopayments/design-system/icons/inline'

import type { CategoryAPI } from '@twisto/api-cms'

import { AccessibleDiv } from 'homepage/components/atoms/accessible-div'

import * as styles from './eshops-navigation.styles'

type CategoriesDropdownProps = {
  label?: string
  categories: CategoryAPI[]
  currentCategory: CategoryAPI | null
  changeCategory: (category: CategoryAPI) => void
}

export const CategoriesDropdown = ({
  label,
  categories,
  currentCategory,
  changeCategory,
}: CategoriesDropdownProps) => (
  <li css={[styles.listItem, styles.dropdownLabel]}>
    {label}

    <ChevronDownIcon size="20" />

    <ul css={styles.dropdownList}>
      {categories.map((category) => (
        <AccessibleDiv
          key={category.id}
          as="li"
          css={[
            styles.listItem,
            currentCategory?.id === category.id && styles.activeItem,
          ]}
          role="button"
          onActivate={() => changeCategory(category)}
        >
          {category.name}
        </AccessibleDiv>
      ))}
    </ul>
  </li>
)
